import { IsEmail } from "class-validator";

export class ResetPasswordPayload {
    @IsEmail()
    emailAddress: string;
}